import { toEmbedUrl } from '../../lib/embed-url';
import { baseComponents } from './base-components';

type ImgProps = React.ImgHTMLAttributes<HTMLImageElement>;

/**
 * Рендер `![Заголовок](https://kinescope.io/...)` как встроенного плеера.
 *
 * Синтаксис картинки выбран намеренно: он привычен в Markdown и не требует
 * ни сырого HTML, ни ослабления sanitize-схемы — `<img>` и так разрешён.
 * Если ссылка не с разрешённого видеохостинга, отдаём обычную картинку.
 */
export function VideoEmbed(props: ImgProps) {
	const { src, alt, title } = props;
	const embedUrl = typeof src === 'string' ? toEmbedUrl(src) : null;

	if (!embedUrl) {
		const Img = baseComponents.img as (p: ImgProps) => React.ReactElement;
		return <Img {...props} />;
	}

	return (
		<iframe
			src={embedUrl}
			title={title || alt || 'Видео'}
			allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
			allowFullScreen
			loading="lazy"
			referrerPolicy="strict-origin-when-cross-origin"
			className="mt-4 aspect-video w-full rounded-lg border-0"
		/>
	);
}
